<template>
  <div class="act-vote-rank" v-if="character_list && character_list.length>0">
    <div class="main-candidate">
      <div class="candidate">
        <div class="candidate-left">
          <img class="top-avatar" :src="top.photo" @click="handleAvatar(top)">
        </div>
        <div class="candidate-right">
          <div class="table">
            <div class="table-cell">
              <div class="edit_tip"  v-if="is_edit">{{top.char_name}}</div>
              <div class="tips tips-first" :style="vote_font_style">{{vote_font_text.replace('${N}',top.vote_num)}}</div>
              <div class="btn btn-vote_1" @click="handleVote(top)">
                <img class="btn-bg-first" :src="info.vote_btn_1">
              </div>
              <div class="btn btn-vote_all" @click="handleVote(top,remain_times)">
                <img class="btn-bg-first" :src="info.vote_btn_all">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="other-candidate">
      <div class="row" v-for="(group_item,index) in other_groups" :key="'og_'+index">

        <div class="candidate" v-for="(item,index) in group_item" :key="index" v-if="item.photo">
          <img class="avatar" :src="item.photo" @click="handleAvatar(item)">
          <div class="edit_tip" v-if="is_edit">{{item.char_name}}</div>
          <div class="tips" :style="vote_font_style">{{vote_font_text.replace('${N}',item.vote_num)}}</div>
          <div class="btn-group">
            <div class="btn-left" @click="handleVote(item)">
              <img class="btn-bg" :src="info.vote_btn_1">
            </div>
            <div class="btn-right" @click="handleVote(item,remain_times)">
              <img class="btn-bg" :src="info.vote_btn_all">
            </div>
          </div>
        </div>
        <div v-else class="candidate">

        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import {getJSON} from '../../api/myaxios';
  import {USRE_INFO_LOAD} from '../../constant/eventbus'
  import click_handler from '../../tools/mgtv/click';
  import {openLink} from '../../tools/mgtv/link';
  import to_casher from '../../tools/mgtv/casher';
  import handler_action from '../../tools/mgtv/action';
  import {toRem} from '../../tools/tpl'
  import {error_event} from '../../tools/mgtv/analysis'
  import {onUseInfoLoad} from '../../tools/onUseInfoLoad'
  import {GET_VOTE_REMAIN_TIMES, VOTE_FOR_CHAR, SIGN_FOR_VOTE, GET_VOTE_CHAR_LIST} from '../../constant/eventbus'
  import chunk from 'lodash/chunk'


  export default {
    name: 'ActVoteRank',
    props: ['info'],
    filters: {},
    data() {
      return {}
    },
    created() {

      window.$bus.$emit(GET_VOTE_CHAR_LIST);
      onUseInfoLoad(() => {
        window.$bus.$emit(GET_VOTE_REMAIN_TIMES);
        window.$bus.$emit(SIGN_FOR_VOTE);
      }, false);

    },
    computed: {
      top() {
        if (!this.character_list) {
          return {}
        }
        return this.character_list[0];
      },
      other() {
        if (!this.character_list) {
          return [];
        }
        let res = [...this.character_list.slice(1)];
        if (res.length % 2 === 1) {
          res.push({});
        }
        return res

      },
      other_groups() {
        return chunk(this.other, 2);
      },
      vote_font_text() {
        return this.info.vote_font_text || '当前票数：${N}票'
      },
      vote_font_style() {
        let style = {
          fontSize: toRem(this.info.vote_font_size) || '0.25rem',
          color: this.info.vote_font_color || 'white'
        }
        return style;
      },
      remain_times() {
        return window.$bus.vote.remain_times;
      },
      character_list() {
        return window.$bus.vote.character_list
      },
      is_edit(){
        return window.gact.edit
      }
    },
    methods: {

      handleNoTimes() {
        console.log('handleNoTimes')
        //no_times
        const action_type = this.info.action_type_notimes;
        const action_info = this.info.action_info_notimes;
        if (action_type) {
          let success_cb = null;
          if (action_type === 'showRulerDialog') {
            success_cb = () => { //success cb ,弹窗回调
              const modal_type = this.info.action_type_notimes_modal;
              const modal_info = this.info.action_info_notimes_modal;
              if (modal_type) {
                handler_action({
                  action_info: modal_info,
                  action_type: modal_type
                })
              }
            }
          }
          handler_action({
            action_type,
            action_info
          }, success_cb)
        }
      },

      handleVote(character, vote_num = 1) {
        const event_name = `${this.info.name}-投票`;
        click_handler(event_name, () => {
          if (this.remain_times <= 0) {
            this.handleNoTimes();
            return;
          }

          if(vote_num > 1){
            this.$dialog.confirm({
              message: `即将投${vote_num}票给${character.char_name}`
            }).then(()=>{
              window.$bus.$emit(VOTE_FOR_CHAR, character.char_id, vote_num,this.voteSuccess);
            }).catch(() => {
              console.log('取消')
            });
          }else{
            window.$bus.$emit(VOTE_FOR_CHAR, character.char_id, vote_num,this.voteSuccess);
          }

        }, {
          need_act: true,
          need_login: true,
          need_new_user: this.info.need_new_user,
          need_vip_level: this.info.need_vip_level,
        });

      },
      handleAvatar(candidate) {
        console.log(candidate);
      },
      voteSuccess() {
        console.log('voteSuccess')
        //no_times
        const action_type = this.info.action_type_success;
        const action_info = this.info.action_info_success;
        if (action_type && action_type !== 'none') {
          let success_cb = null;
          if (action_type === 'showRulerDialog') {
            success_cb = () => { //success cb ,弹窗回调
              const modal_type = this.info.action_type_success_modal;
              const modal_info = this.info.action_info_success_modal;
              if (modal_type) {
                handler_action({
                  action_info: modal_info,
                  action_type: modal_type
                })
              }
            }
          }
          handler_action({
            action_type,
            action_info
          }, success_cb)
        }else{
          window.$toast('投票成功');
        }
      }
    },
    mounted() {

    }
  }
</script>
<style lang="stylus" scoped>
  .act-vote-rank
    position relative
    width 7.5rem
    .edit_tip
      position absolute
      top 0
      left  0
      font-size .5rem
      color red
    .main-candidate
      .candidate
        margin 0 auto
        display flex
        padding-left 0.5rem
    .candidate
      position relative
      &-left
        flex 4
      &-right
        flex 4
        padding 0 0.2rem
      .top-avatar
        width 3.8rem
        height 3.8rem
      .avatar
        width 3.1rem
        height 3.15rem
      .tips
        font-size 0.24rem
        text-align center
        margin-top 0.1rem
        margin-bottom 0.1rem
        color white
        &-first
          margin-bottom 0.4rem
      .btn
        text-align center
        &:last-child
          margin-top 0.2rem
    .other-candidate
      margin-top 0.4rem
      padding 0 0.4rem
    .btn-group
      display flex
      .btn-left
        flex 1
        text-align right
        margin-right .05rem
      .btn-right
        flex 1
        text-align left
    .btn-bg
      width 1.5rem
      height 0.6rem
      &-first
        width 2rem
        height 0.75rem
    .row
      display flex
      margin-bottom 0.15rem
      justify-content space-between
      .candidate
        text-align center
    .table
      display table
      width 100%
      height 100%
      &-cell
        display table-cell
        vertical-align middle
</style>





// WEBPACK FOOTER //
// src/components/ConfigUI/ActVoteRank.vue